import React, { Component } from "react";
import ReactDOM from "react-dom";

import { ENDPOINTS } from "../../constants/endpoints";

class RPImgcreditPayment extends Component {
  constructor(props) {
    super(props);
    this.state = { no_of_imgcredits: 1, ...props };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {}

  componentDidMount() {}

  amount = this.props.amount;
  uid = this.props.uid;

  render() {
    const style = {
      color: "green"
    };

    const style3 = {
      color: "white",
      fontSize: 17,
      background: "green"
    };

    return (
      <div style={style}>
        <form
          id="redirect"
          method="post"
          name="redirect"
          action="/rpimgcredittransactions"
        >
          <input type="hidden" name="amount" value={this.amount} />
          <input
            type="hidden"
            name="no_of_imgcredits"
            value={this.props.no_of_imgcredits}
          />
          <input
            type="hidden"
            name="convenienceCharges"
            value={this.props.convenienceCharges}
          />
          <input type="hidden" name="uid" value={this.uid} />
          <button type="submit" style={style3} className="btn btn-success">
            Razorpay Checkout
          </button>
        </form>
      </div>
    );
  }
}

export default RPImgcreditPayment;
